<script>
  import './saleListing.css'
  import SaleRow from './SaleRow.svelte'
  import { signerAddress } from 'svelte-ethers-store'
  import ConnectWallet from '../ConnectWallet.svelte'
  import { getProjectListingService } from '../../../../services/projectDetailService'
  import { onMount } from 'svelte'
  import Pagination from '../../../components/pagination/Pagination.svelte'

  onMount(() => {
    window.scrollTo(0, 0)
  })

  let loading = false
  let items = []
  let currentPage = 1
  let pageCount = 0
  let response

  $: if ($signerAddress) {
    fetchSales()
  }

  let fetchSales = async () => {
    try {
      loading = true
      response = await getProjectListingService($signerAddress)
      items.push(...response.projects)
      pageCount = response.pagination.pageCount
      loading = false
    } catch (e) {
      loading = false
    }
  }

  const pageChange = async (page) => {
    currentPage = page
    response = await getProjectListingService($signerAddress, page)
    items = [...response.projects]
  }
</script>

{#if $signerAddress}
  <div class="sale-listing-wrapper flex flex-wrap">
    <div class="container">
      <div class="flex items-start sales-titles items-center">
        <h2 class="table-title">My Projects</h2>
        <div class="refresh-icon ml-auto">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            color="#E426B2"
            on:click={() => {
              items = []
              currentPage = 1
              fetchSales()
            }}
            class={loading ? 'rotate' : ''}>
            <polyline points="23 4 23 10 17 10" />
            <polyline points="1 20 1 14 7 14" />
            <path
              d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0
              20.49 15" />
          </svg>
        </div>
      </div>
      <div class="sale-list-table flex flex-wrap">
        {#if loading}
          <div class="sale-loader flex justify-center">
            <img src="./images/btn-load.gif" alt="btn-load" />
          </div>
        {:else if items.length}
          <table>
            <thead>
              <tr>
                <th>Project Name</th>
                <th>Sales Address</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Raise Type</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {#each items as data}
                <SaleRow
                  projectID={data.id}
                  projectDescription={data.attributes.project_description}
                  projectName={data.attributes.project_name}
                  saleAddress={data.attributes.sale_address}
                  startTime={data.attributes.project_start_time}
                  endTime={data.attributes.project_end_time}
                  saleType={data.attributes.raise_type}
                  status={data.attributes.project_status}
                  draft={!data.attributes.publishedAt} />
              {/each}
            </tbody>
          </table>
        {:else}
          <div
            class="no-listing flex flex-wrap column-direction text-center
            justify-center">
            <p>No Sale Available</p>
          </div>
        {/if}
      </div>
      {#if pageCount > 1}
      <div class="flex items-center justify-center">
        <Pagination current={currentPage} count={pageCount} setCurrentPage={pageChange} />
      </div>
      {/if}
    </div>
  </div>
{:else}
  <ConnectWallet />
{/if}
